import type { Command } from 'commander';
import { registerConfigSet } from './set';
import { registerConfigGet } from './get';
import { registerConfigPath } from './path';
import { registerConfigReset } from './reset';

export function registerConfigCommand(program: Command): void {
	const config = program.command('config').description('Manage CLI configuration');
	registerConfigSet(config);
	registerConfigGet(config);
	registerConfigPath(config);
	registerConfigReset(config);
}
